export default __webpack_public_path__ + "static/media/CivicImage.593aed65.png";